import { useUserPoints } from "@/hooks/useUserPoints";

export default function PointsBadge() {
  const { balance, loading } = useUserPoints();
  if (loading) return null;
  return (
    <span
      className="inline-flex items-center justify-center gap-1 px-2.5 py-1 text-xs font-stat text-[hsl(var(--tertiary))] min-h-[48px] min-w-[48px]"
      title={`${balance} mérite${balance > 1 ? "s" : ""}`}
    >
      <span className="text-[11px]">⚡</span>
      {balance}
    </span>
  );
}
